"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrow_chart_line_down = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const arrow_chart_line_down = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'arrow-chart-line-down-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M17.5303 15.2803C17.8232 14.9874 17.8232 14.5126 17.5303 14.2197L11.0303 7.71967C10.7374 7.42678 10.2626 7.42678 9.96967 7.71967L8 9.68934L3.53033 5.21967C3.23744 4.92678 2.76256 4.92678 2.46967 5.21967C2.17678 5.51256 2.17678 5.98744 2.46967 6.28033L7.46967 11.2803C7.76256 11.5732 8.23744 11.5732 8.53033 11.2803L10.5 9.31066L16.4697 15.2803C16.7626 15.5732 17.2374 15.5732 17.5303 15.2803Z', fill: '#4B5563' }),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M12.25 14.75C12.25 15.1642 12.5858 15.5 13 15.5L17 15.5C17.4142 15.5 17.75 15.1642 17.75 14.75V10.75C17.75 10.3358 17.4142 10 17 10C16.5858 10 16.25 10.3358 16.25 10.75V14L13 14C12.5858 14 12.25 14.3358 12.25 14.75Z', fill: '#4B5563' })));
};
exports.arrow_chart_line_down = arrow_chart_line_down;
